import { getSystemConfigQuery } from "../../graphql/queries";
import type { GetSystemConfigQuery, GetSystemConfigQueryVariables } from "../../graphql/types";
import { fetchGraphql, type GraphQlResult } from "./graphqlClient";

export async function fetchSystemConfig(): Promise<GraphQlResult<GetSystemConfigQuery>> {
    return await fetchGraphql<GetSystemConfigQuery, GetSystemConfigQueryVariables>("GetSystemConfig", getSystemConfigQuery, {});
}
